import { CommonModule, DatePipe } from "@angular/common";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { BacDashboardInformation } from "../../../../core/models/dashboard-poc/bacDashboardInformation";
import { BilledOrdersYtdResponse } from "../../../../core/models/dashboard-poc/billedOrdersYtdResponse";
import { BacDashboardInformationRequest } from "../../../../core/models/dashboard-poc/bacDashboardInformationRequest";
import { Router } from "@angular/router";
import {
  GetManagerReportPdfRequest,
  ManagerReportBacHtml,
  ManagerReportBcHtml,
} from "../../../../core/models/dashboard-poc/getManagerReportPdfRequest";
import { AddManagerNotesRequestDto } from "../../../../core/models/dashboard-poc/addManagerNotesRequestDto";
import { YtdSummaryData } from "../../../../core/models/bcLedger/ytdSummaryDataDto";
import { YtdSummaryRequestDto } from "../../../../core/models/bcLedger/ytdSummaryRequestDto";
import { DashbaordPocAdditionalFilters } from "../../../../core/models/common/dashboardPocAdditionalFilters.dto";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { Employee } from "../../../../core/models/profile/employee";
import { GetUserDto } from "../../../../core/models/users/users/getUserDto";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { BcledgerService } from "../../../../core/services/bcledger.service";
import { CommonService } from "../../../../core/services/common.service";
import { DashboardPocService } from "../../../../core/services/dashboard-poc.service";
import { LoaderService } from "../../../../core/services/loader.service";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { UserSupportMapService } from "../../../../core/services/user-support-map.service";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { BcledgerFilterComponent } from "../../../bcledger/components/bcledger-filter/bcledger-filter.component";
import { BCLedgerFilter } from "../../../../core/models/bcLedger/bclegderfilter";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { LocationWiseQ3Grid1Component } from "../location-wise-q3-grid1/location-wise-q3-grid1.component";
import { LocationWiseQ3Grid2Component } from "../location-wise-q3-grid2/location-wise-q3-grid2.component";
import { Q3ReportLocationWiseBcReportDto } from "../../../../core/models/dashboard-poc/q3ReportLocationWiseBcReportDto";
import { Q3SecondGridReportLocationWiseBcReportDto } from "../../../../core/models/dashboard-poc/q3SecondGridReportLocationWiseBcReportDto";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-manager-report",
  templateUrl: "./manager-report.component.html",
  styleUrls: ["./manager-report.component.scss"],
  providers: [DatePipe],
  imports: [
    BcledgerFilterComponent,
    CommonModule,
    LocationWiseQ3Grid1Component,
    LocationWiseQ3Grid2Component,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class ManagerReportComponent implements OnInit {
  @Input() isSuperManagerInput = false;
  @Input() isAdmin = false;
  ytdSummaryList: YtdSummaryData[] = [];
  bcLedgerFilter: BCLedgerFilter = {} as BCLedgerFilter;
  bacDashboardInformation: BacDashboardInformation[] = [];
  billedOrdersYTD: BilledOrdersYtdResponse[] = [];
  userData!: GetUserDto;
  bcList: Employee[] = [];
  brandingConsultantSection = false;
  showBrandingConsultantWhoSupportsMeDropDown = false;
  userRole = 0;
  personalNumber = "";
  dashbaordPocAdditionalFilters: DashbaordPocAdditionalFilters =
    {} as DashbaordPocAdditionalFilters;

  currentSupportPercentage = 0;
  nextCommissionTier = 0;

  isBAC = false;

  isManager = false;
  isSuperManager = false;

  grid1: Q3ReportLocationWiseBcReportDto[] = [];
  grid2: Q3SecondGridReportLocationWiseBcReportDto[] = [];

  location = "";

  overrideManager = false;
  showRemoveFilter = false;

  disableDropDown = false;

  bcSelectedId = "";

  currentQuarter = "";

  qr4 = [
    { support: 25, q4GP: 212_500 },
    { support: 50, q4GP: 425_000 },
    { support: 75, q4GP: 637_500 },
    { support: 100, q4GP: 850_000 },
  ] as { support: number; q4GP: number }[];

  @ViewChild("filter", { static: false }) filter!: BcledgerFilterComponent;

  constructor(
    private _loaderService: LoaderService,
    private _dashboardPocService: DashboardPocService,
    private _loginService: UserManagementService,
    private _profileFormService: ProfileFormService,
    private _bcledgerService: BcledgerService,
    private _toastr: JniToastrService,
    private _commonService: CommonService,
    private _userSupportMapService: UserSupportMapService,
    private _router: Router
  ) {}
  ngOnInit() {
    this.getUserProfile();
    this.getCurrentQuarter();
  }

  GetSalesOrderBacInformationForCharts() {
    this._loaderService.setLoaderState(true);
    this._dashboardPocService
      .GetSalesOrderBacInformationForCharts(this.getCurrentYtdLogic())
      .subscribe({
        next: res => {
          if (res.data != null) {
            this._loaderService.setLoaderState(false);
            this.bacDashboardInformation = res.data?.bacDashboardInformation;
            let supportPercentageSum = 0;
            this.bacDashboardInformation.forEach(
              x => (supportPercentageSum += x.supportPercentage)
            );
            this.currentSupportPercentage = supportPercentageSum;
            this.nextCommissionTier =
              (Math.floor(this.currentSupportPercentage / 100) +
                1 -
                this.currentSupportPercentage / 100) *
              212500;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getBilledOrdersYTD() {
    this._loaderService.setLoaderState(true);
    this._dashboardPocService
      .getBilledOrdersYTD(this.getCurrentYtdLogic())
      .subscribe({
        next: res => {
          if (res.data != null) {
            this._loaderService.setLoaderState(false);
            this.billedOrdersYTD = res.data;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getManagerReportPdf() {
    this._loaderService.setLoaderState(true);

    const request = {} as GetManagerReportPdfRequest;
    const reportBcList: ManagerReportBcHtml[] = [];
    const reportBacList: ManagerReportBacHtml[] = [];

    this.grid1.forEach(x => {
      const reportBc = {} as ManagerReportBcHtml;
      reportBc.bc = x?.bc;
      reportBc.bacBas = x?.cordinatorAndSupport;
      reportBc.currentSupportQ2 = x?.currentSupport;
      reportBc.currentYtdGpPercentage = x?.currentYtdGp;
      reportBc.gpBacklog = x?.gpBacklog;
      reportBc.notes = x?.notes;
      reportBc.runningTwelveMonthGp = x?.runningTwelveMonthGp;
      reportBc.supportBasedOffNumbers = x?.supportBasedOffNumbers;
      reportBc.supportDifference = x?.supportDifference;
      reportBcList.push(reportBc);
    });

    this.grid2.forEach(x => {
      const reportBac = {} as ManagerReportBacHtml;
      reportBac.notes = x?.notes;
      reportBac.supportBreakdown = x?.bc;
      reportBac.supportPercentageBasedOffNumbers = x?.supportBasedOffNumber;
      reportBac.title = x?.title;
      reportBacList.push(reportBac);
    });

    request.locationName = this.location;
    request.managerReportBac = reportBacList;
    request.managerReportBc = reportBcList;
    request.currentQuarter = this.currentQuarter;

    this._dashboardPocService.getManagerReportPdf(request).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          const blob = this.b64toBlob(res.data, "application/pdf");
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        } else {
          this._toastr.error(
            "Error",
            `${res.message || "Failed to Generate the Pdf"}`
          );
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "got error while generating Pdf");
      },
    });
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  getCurrentYtdLogic() {
    const obj: BacDashboardInformationRequest = {
      fromDate: this.bcLedgerFilter.fromDate,
      toDate: this.bcLedgerFilter.toDate,
      personnelNumber: "",
    };

    if (this.userRole == UserRole.Admin) {
      obj.personnelNumber = this.bcLedgerFilter.brandingConsultantID;
    } else {
      obj.personnelNumber =
        this.bcLedgerFilter.brandingConsultantID ??
        this.userData.personnelNumber ??
        "";
    }

    return obj;
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.userRole = res.data.userRoleId;
        if (this.userRole === UserRole.Admin) {
          this.brandingConsultantSection = true;
          this.showBrandingConsultantWhoSupportsMeDropDown = false;
          // this.getAllBrandingConsultantDashboardPoc();

          // for manager view

          this.getAllManagerEmployees();
        }

        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res?.data) {
          this.userData = res?.data;
          this.isSuperManager = res?.data.superManagerAccess;
          this.filter.bcSelectedId = res.data.personnelNumber;
          if (
            (res?.data?.managerAccess ||
              this.userRole == UserRole.Admin ||
              res?.data?.superManagerAccess) &&
            !this.overrideManager
          ) {
            this.isManager = true;
            this.location = res.data.locationName || "";
            this.getQ3ReportLocationWiseBcReport();
            this.getQ3SecondGridReportLocationWiseBcReport();
          }
          if (this.overrideManager) {
            this.isManager = false;
          }

          if (this.isSuperManager) {
            this.brandingConsultantSection = true;
            this.showBrandingConsultantWhoSupportsMeDropDown = false;
            this.disableDropDown = false;
            this.getAllManagerEmployees();
          } else if (this.isManager && this.userRole != UserRole.Admin) {
            if (
              res?.data.loginEmail &&
              res?.data?.title?.toLowerCase()?.includes("branding consultant")
            ) {
              this.disableDropDown = true;
              this.selectBcData();
              this.filter.bcSelectedId = this.userData.personnelNumber;
              this.brandingConsultantSection = true;
            } else {
              // this.getAllBacWithSameLocation();
            }
          }

          // if (this.userRole != UserRole.Admin) {
          //   this.brandingConsultantSection = false;
          //   this.showBrandingConsultantWhoSupportsMeDropDown = true;
          //   if (
          //     res?.data.loginEmail &&
          //     res?.data?.title?.toLowerCase()?.includes('branding consultant')
          //   ) {
          //     this.getWhoeSupportsMeBrandingConsultant(res.data.loginEmail);
          //   } else {
          //     this.isBAC = true;
          //   }
          //   this.changeBrandingConsultant();
          // }
          //  if(this.userRole == UserRole.Admin)
          //   {
          //     this.getYtdSummary();
          //   }
        }
      },
    });
  }

  selectBcData() {
    this.bcList = [
      {
        firstName: this.userData.name,
        personnelNumber: this.userData.personnelNumber,
      },
    ];
  }

  getYtdSummary() {
    if (this.userRole == UserRole.Admin) {
      this.personalNumber = this.bcLedgerFilter.brandingConsultantID ?? "";
    } else {
      this.personalNumber =
        this.bcLedgerFilter?.brandingConsultantID ??
        this.userData.personnelNumber ??
        "";
    }

    if (this.personalNumber == undefined || this.personalNumber == "") {
      return;
    }
    // const ytdDates = this.getCurrentYtdLogic();

    const currentDate = new Date();

    const toDate = `${
      currentDate.getMonth() + 1
    }/${currentDate.getDate()}/${currentDate.getFullYear()}`;
    const fromDate = new Date(currentDate);
    fromDate.setFullYear(currentDate.getFullYear() - 1);

    if (currentDate.getDate() !== fromDate.getDate()) {
      fromDate.setDate(0);
    }

    const fromDateString = `${
      fromDate.getMonth() + 1
    }/${fromDate.getDate()}/${fromDate.getFullYear()}`;

    const ytdSummaryPayload: YtdSummaryRequestDto = {
      FromDate: fromDateString,
      ToDate: toDate,
      BrandingConsultantID: this.personalNumber,
    };

    this._loaderService.setLoaderState(true);
    this._bcledgerService.ytdSummary(ytdSummaryPayload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data != null) {
          const summary = res.data.Data ?? [];
          this.ytdSummaryList = summary.map(x => {
            const ytdGpDivide = Math.floor(
              (x.YTGP / this.qr4[this.qr4.length - 1].q4GP) * 100
            );

            const { currentTier, nextTier } = this.getCurrentAndNextTierValue(
              ytdGpDivide,
              x.YTGP
            );
            x.CommissionTierDashboard = currentTier;
            x.NextCommissionTier = nextTier;
            return x;
          });
        }
        if (res?.status?.toLowerCase() !== "success") {
          this._toastr.error("YTD Error", res.message || "YTD Error");
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  getCurrentAndNextTierValue(ytdGpDivide: number, ytgp: number) {
    for (let i = 0; i < this.qr4.length; i++) {
      if (i == 0 && ytdGpDivide < this.qr4[i].support) {
        return {
          currentTier: 0,
          nextTier: Math.abs((this.qr4[i].q4GP || 0) - ytgp),
        } as { currentTier: number; nextTier: number };
      }

      if (
        i + 1 != this.qr4.length &&
        ytdGpDivide >= this.qr4[i].support &&
        ytdGpDivide < this.qr4[i + 1].support
      ) {
        return {
          currentTier: this.qr4[i].support,
          nextTier: this.qr4[i + 1].q4GP - ytgp,
        } as { currentTier: number; nextTier: number };
      }

      if (i + 1 == this.qr4.length) {
        return { currentTier: ytdGpDivide, nextTier: 0 } as {
          currentTier: number;
          nextTier: number;
        };
      }
    }

    return { currentTier: 0, nextTier: 0 } as {
      currentTier: number;
      nextTier: number;
    };
  }

  getAllBrandingConsultantDashboardPoc() {
    this._commonService.getAllBrandingConsultantDashboardPoc().subscribe({
      next: res => {
        this.bcList = res.data;
      },
    });
  }

  getAllManagerEmployees() {
    this._commonService.getAllManagerEmployees().subscribe({
      next: res => {
        this.bcList = res.data;
      },
    });
  }

  getWhoeSupportsMeBrandingConsultant(loggedInEmail: string) {
    this._userSupportMapService
      .whoSupportMeWithPersonalNumberDashboardPoc(loggedInEmail)
      .subscribe({
        next: res => {
          this.bcList = res.data;
        },
      });
  }

  changeBrandingConsultant() {
    if (
      this.bcLedgerFilter.brandingConsultantID != undefined &&
      this.bcLedgerFilter.brandingConsultantID != "" &&
      (this.userRole === UserRole.Admin || this.isSuperManager)
    ) {
      const bc = this.bcList.find(
        x => x.personnelNumber == this.bcLedgerFilter.brandingConsultantID
      );

      this.location = bc?.locationName ?? "";
      this.getQ3ReportLocationWiseBcReport(bc?.personnelNumber);
      this.getQ3SecondGridReportLocationWiseBcReport(bc?.personnelNumber);
    } else {
      this.ngOnInit();
    }

    // if (
    //   this.userRole !== 0 &&
    //   this.userRole === UserRole.Admin &&
    //   this.bcLedgerFilter.brandingConsultantID != undefined &&
    //   this.bcLedgerFilter.brandingConsultantID != ''
    // ) {
    //   const ytdLogic = this.getCurrentYtdLogic();
    //   this.dashbaordPocAdditionalFilters.brandingConsultant =
    //     ytdLogic.personnelNumber || '';
    //   this.dashbaordPocAdditionalFilters.fromDate = ytdLogic.fromDate || '';
    //   this.dashbaordPocAdditionalFilters.toDate = ytdLogic.toDate || '';
    //   this._sharedService.setDashbaordPocAdditionalFiltersObject(
    //     this.dashbaordPocAdditionalFilters
    //   );
    //   this.GetSalesOrderBacInformationForCharts();
    //   this.getBilledOrdersYTD();
    //   this.getYtdSummary();
    // } else if (this.userRole !== 0 && this.userRole !== UserRole.Admin) {
    //   const ytdLogic = this.getCurrentYtdLogic();
    //   this.dashbaordPocAdditionalFilters.brandingConsultant =
    //     ytdLogic.personnelNumber || '';
    //   this.dashbaordPocAdditionalFilters.fromDate = ytdLogic.fromDate || '';
    //   this.dashbaordPocAdditionalFilters.toDate = ytdLogic.toDate || '';
    //   this._sharedService.setDashbaordPocAdditionalFiltersObject(
    //     this.dashbaordPocAdditionalFilters
    //   );
    //   this.GetSalesOrderBacInformationForCharts();
    //   this.getBilledOrdersYTD();
    //   this.getYtdSummary();
    // }
  }

  getBcLedgerFormData(bcLedgerFilter: BCLedgerFilter) {
    this.bcLedgerFilter = { ...bcLedgerFilter };
    this.changeBrandingConsultant();
    // this.showRemoveFilter = true;
  }

  getQ3ReportLocationWiseBcReport(personnelNumber = "") {
    this.grid1 = [];
    this._loaderService.setLoaderState(true);
    this._dashboardPocService
      .getQ3ReportLocationWiseBcReport(personnelNumber)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status.toLowerCase() == "success") {
            this.grid1 = res.data;
          } else {
            this.grid1 = [];
            this._toastr.error(
              "Error",
              res.message || "Error fetching location wise report grid 1"
            );
          }
        },
        error: () => {
          this.grid1 = [];
          this._toastr.error(
            "Error",
            "Error fetching location wise report grid 1"
          );
        },
      });
  }

  getQ3SecondGridReportLocationWiseBcReport(personnelNumber = "") {
    this.grid2 = [];
    this._dashboardPocService
      .getQ3SecondGridReportLocationWiseBcReport(personnelNumber)
      .subscribe({
        next: res => {
          if (res.status.toLowerCase() == "success") {
            this.grid2 = res.data;
          } else {
            this.grid2 = [];
            this._toastr.error(
              "Error",
              res.message || "Error fetching location wise report grid 2"
            );
          }
        },
        error: () => {
          this.grid2 = [];
          this._toastr.error(
            "Error",
            "Error fetching location wise report grid 2"
          );
        },
      });
  }

  removeFilter(event: boolean) {
    // this.overrideManager = true;
    // this.isManager = false;
    if (event) {
      this.ngOnInit();
    }
  }

  bcSelectedEvent() {
    // this.showRemoveFilter = true;
  }

  removeFilterButtonEvent() {
    this.filter.bcSelectedId = "";
    this.grid1 = [];
    this.location = "";
    this.bacDashboardInformation = [];
    // this.dashbaordPocAdditionalFilters = {};
    this.grid2 = [];
    this.bacDashboardInformation = [];
    // this.dashbaordPocAdditionalFilters = {};
    this.billedOrdersYTD = [];
    this.ytdSummaryList = [];
    this.bcLedgerFilter = {};
    this.currentSupportPercentage = 0;
    this.nextCommissionTier = 0;
    this.overrideManager = false;
    this.isManager = false;
    this.filter.ngOnInit();
    this.ngOnInit();
    this.showRemoveFilter = false;
  }

  showFilterButton() {
    this.showRemoveFilter = true;
  }

  redirectToSupportDashboard(bcLedgerFilter: BCLedgerFilter) {
    this._router.navigate(["dashboard-poc"], {
      state: {
        bcLedgerFilter,
      },
    });
  }

  onNotesSubmit(data: {
    manager: string;
    bcPersonnelNumber: string;
    notes: string;
    type: string;
  }) {
    const request = {
      bcPersonnelNumber: data.bcPersonnelNumber,
      manager: data.manager,
      notes: data.notes,
      type: data.type,
    } as AddManagerNotesRequestDto;

    this.addOrUpdateManagerNotes(request);
  }

  addOrUpdateManagerNotes(request: AddManagerNotesRequestDto) {
    this._loaderService.setLoaderState(true);
    this._dashboardPocService.AddOrUpdateManagerNotes(request).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.status.toLowerCase() == "success") {
          this._toastr.success(res.message, "Success");
          this.changeBrandingConsultant();
        } else {
          this._toastr.error(res.message, "Error");
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  getCurrentQuarter() {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();

    // Define quarters using a Map
    const quartersMap = new Map([
      [0, "Q4"],
      [1, "Q4"],
      [2, "Q4"], // January, February, March => Quarter 4
      [3, "Q1"],
      [4, "Q1"],
      [5, "Q1"], // April, May, June => Quarter 1
      [6, "Q2"],
      [7, "Q2"],
      [8, "Q2"], // July, August, September => Quarter 2
      [9, "Q3"],
      [10, "Q3"],
      [11, "Q3"], // October, November, December => Quarter 3
    ]);

    // Determine current quarter based on current month
    this.currentQuarter = quartersMap.get(currentMonth) ?? "";
  }
}
